import native from "./native";
export default {
  info: {
    key: "ruby",
    title: "Ruby",
    extname: ".rb",
    default: "native"
  },
  native: native
};